var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6971_31894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8465 2.36669C49.7645 2.54507 49.6517 2.70757 49.5132 2.84669L17.9998 34.3534L26.8998 49.19C27.0575 49.4539 27.2851 49.669 27.5574 49.8116C27.8297 49.9542 28.1361 50.0187 28.4428 49.998C28.7495 49.9773 29.0444 49.8722 29.2951 49.6943C29.5458 49.5164 29.7424 49.2727 29.8632 48.99L49.8465 2.36669ZM15.6465 32L0.809833 23.0934C0.545968 22.9357 0.330844 22.7081 0.188246 22.4358C0.0456482 22.1635 -0.018868 21.8571 0.00183047 21.5504C0.022529 21.2437 0.127636 20.9487 0.30553 20.6981C0.483424 20.4474 0.727175 20.2508 1.00983 20.13L47.6432 0.150024C47.4622 0.232318 47.2973 0.346337 47.1565 0.486691L15.6465 32Z",
    fill: "black",
    fillOpacity: 0.06
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6971_31894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdSend);
export default __webpack_public_path__ + "static/media/MdSend.c36ae674830a733edcd11ed31d2f1443.svg";
export { ForwardRef as ReactComponent };